import React, { useContext } from 'react'
import OptionsContainer from '../../components/OptionsContainer';
import Footer from './Footer';
import FooterContainer from '../FooterContainer'
import context from '../../context'
import FromToPicker from '../../components/FromToPicker';

function Sport() {
  const { options, searchOptions, handleSearchOptionChange } = useContext(context)
  console.log(options.mainCoverage)

  const handleMainCoverageChange = (e) => {
    handleSearchOptionChange({ mainCoverage: e.target.value });
  }

  const handleDurationChange = (e) => {
    handleSearchOptionChange(e);
  }

  return (
    <>
      <div className="mt-3 mt-md-0">
        <div className="row">
          {/* left */}
          <div className="col-12 col-lg-6 py-0 pt-md-4">
            <h5 className="title-line-primary d-none d-md-block">選擇投保期間</h5>
            <h6 className="title-line-primary d-md-none d-block">選擇投保期間</h6>
            <div className="row px-3 mb-4">
              <FromToPicker
                from={searchOptions.insuredFrom}
                to={searchOptions.insuredTo}
                duration={searchOptions.duration}
                onChange={handleDurationChange}
              />
            </div>
          </div>
          {/* right */}
          <div className="col-12 col-lg-6 py-0 pt-md-4">
            <h5 className="title-line-primary d-none d-md-block">選擇保額</h5>
            <h6 className="title-line-primary d-md-none d-block">選擇保額</h6>
            <OptionsContainer
              options={options.mainCoverage}
              value={searchOptions.mainCoverage}
              onChange={handleMainCoverageChange}
            />
          </div>
          <div className="col-12 ">
            <p className="text-gray-500 small">
              ◎ 運動險/登山險以24小時計算單位，若未滿24小時，系統將自動加計一天投保。<br />
              ◎ 法定網路投保須年滿18，並限本人投保。<br />
              ◎ 運動險/登山險限制須為中華民國境內(指臺澎金馬及政府統治權所及之地區)之行程，若為境外行程，請勿投保。
            </p>
          </div>
        </div>
      </div>
      <FooterContainer>
        <Footer />
      </FooterContainer>
    </>
  )
}

export default Sport


